import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

export const getReportsStatisticsRequest = (
  organizationId,
  restaurantId,
  startDate,
  endDate,
  token
) => {
  const url = `${apiURl}statistics/organization/${organizationId}/restaurant/${restaurantId}/report?startDate=${startDate}&endDate=${endDate}`;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};
